import React from 'react';
import { User } from "lucide-react";

const DashboardHero = ({ userProfile }) => {
    return (
        <div className="dashboard-hero">
            {userProfile?.fullPath ? (
                <img
                    src={userProfile.fullPath}
                    alt="User Avatar"
                    className="dashboard-hero-avatar"
                />
            ) : (
                <div className="dashboard-hero-avatar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#e3ecf7' }}>
                    <User size={32} color="#013e7d" />
                </div>
            )}
            <div>
                <div className="dashboard-hero-greeting">
                    Welcome back{userProfile?.name ? `, ${userProfile.name}` : ''}!
                </div>
                <div className="dashboard-hero-tagline">
                    Your Safety Portal
                </div>
                {userProfile?.organization && (
                    <div className="dashboard-hero-org">
                        {userProfile.organization}
                    </div>
                )}
            </div>
        </div>
    );
};

export default DashboardHero; 